// extracted by mini-css-extract-plugin
export default {"loading":"LoadingModal_loading__VvcJ4","loadingIcon":"LoadingModal_loadingIcon__oXlqR"};